<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>View Plan</strong>
            <div class="card-header-actions">
              <button type="submit" class="btn btn-primary">
                Edit Plan
              </button>
            </div>
          </div>
          <div>
            <input
              type="checkbox"
              class="aprrovedcheck"
              @click="checkAll()"
              v-model="isCheckAll"
            />&nbsp;Select All
          </div>
          <b-table
            responsive
            :busy="isBusy"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-direction="sortDirection"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            <template slot="checkbox" slot-scope="row">
              <input
                type="checkbox"
                @change="(e) => handleCheck(row.item.loadid, e.target.checked)"
                v-model="checked_values"
                required="checked_values"
                v-bind:value="row.item.loadid"
              />
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
  data: function() {
    return {
      items: [],
      fields: [
        {
          key: "checkbox",
          label: "Select check box",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientname",
          label: "Client name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loadid",
          label: "Load Id",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "no_of_boxes",
          label: "No. of boxes",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loadstatus",
          label: "Load status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "shippingreferenceno",
          label: "Shipping reference no",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "userid",
          label: "user Id",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "companyname",
          label: "Compnay Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "destinationcity",
          label: "Dest City",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "destinationstate",
          label: "Dest State",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "warehouseid",
          label: "Warehouse Id",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "warehousename",
          label: "Warehouse name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loadpotype",
          label: "Load prototype",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "shipmentvolumetric_weight",
          label: "Sipping Volumetric weight",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "shippingcode",
          label: "Shipping code",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "",
          label: "Unloading sequence",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "delivery_mode",
          label: "Delivery mode",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vehicle_no",
          label: "Vehicle no",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "",
          label: "Hub",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      isCheckAll: false,
      items_data_checkedList: [],
      checked_values: [],
      approvedcount: 0,
    };
  },

  created: function() {
    this.id = this.$route.params.id;
    console.log("IDDDDD", this.id);

    this.getLoadDetailsOfPlan();
  },

  methods: {
    getLoadDetailsOfPlan: function() {
      const obj = {
        planid: this.id,
      };

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getLoadDetailsOfPlan`, obj)
        .then((result) => {
          this.isBusy = false;
          if (result.body.returnmsg === "Successful") {
            this.items = result.body.returnvalue;
            this.approvedcount = 0;
            for (var i = 0; i < this.items.length; i++) {
              this.items_data_checkedList.push(this.items[i].loadid);

              if (this.isCheckAll) {
                this.checked_values.push(this.items[i].loadid);
              }
              this.approvedcount++;
            }
          } else {
            //  this.showdata = []
            this.items = [];
            // this.totalRows = 0;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },

    checkAll: function() {
      this.checked_values = [];
      this.isCheckAll = !this.isCheckAll;
      console.log(this.items_data_checkedList);
      if (this.isCheckAll) {
        // Check all
        for (var item of this.items) {
          this.checked_values.push(item.loadid);
        }

        console.log(this.checked_values);
      } else {
        this.checked_values = [];
        console.log("unchecked-------------------> ", this.checked_values);
      }
    },

    handleCheck: function(id, action) {
      console.log(this.checked_values);
      // console.log(this.approvedcount, "approvedcount");
      if (this.checked_values.length != this.approvedcount) {
        this.isCheckAll = false;
      }
      if (this.checked_values.length == this.approvedcount) {
        this.isCheckAll = true;
      }
    },
  },
};
</script>
